import React, { useRef, useState } from "react";
import styles from "./image.module.css";
import Button from "common/Button";
import { uploadImage } from "utils/queries";

const ImagePicker = ({
  id,
  label,
  value,
  required = false,
  disabled = false,
  ...inputArgs
}) => {
  const inputRef = useRef();
  const [image, setImage] = useState();

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file?.type?.startsWith("image/")) {
      setImage(file);
    }
  };

  console.log("image is", value, image);

  const handleImageUpload = async () => {
    if (!image) return;

    const form = new FormData();
    form.append("file", image);

    try {
      const result = await uploadImage("image", form, true);
      inputArgs.onChange(result?.data?.url || null);
      setImage(null);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  return (
    <div>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label} {required && <span className="required">*</span>}
        </label>
      )}

      <div
        className={styles.container}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
      >
        {!image && !value && (
          <>
            <img
              src="/images/container/uparrow.svg"
              alt="Upload Arrow"
              className={styles.uparrow}
            />
            <Button
              label="Add Image"
              className={styles.button}
              onClick={() => inputRef.current.click()}
              type="button"
            />
            <input
              type="file"
              accept="image/*"
              name="images"
              className={styles.fileInput}
              ref={inputRef}
              required
              onChange={(e) => {
                const file = e.target.files[0];
                if (file?.type?.startsWith("image/")) {
                  setImage(file);
                }
              }}
              hidden
            />
            <span className={styles.draginfo}>or drop images to Upload</span>
          </>
        )}

        {image && (
          <>
            <img
              src={URL.createObjectURL(image)}
              alt="Preview"
              className={styles.imagePreview}
            />
            <div className={styles.actionN}>
              <Button
                label="Remove"
                className={styles.cButton}
                type="button"
                onClick={() => setImage(null)}
              />
              <Button
                label="Upload"
                className={styles.cButton}
                type="button"
                onClick={handleImageUpload}
              />
            </div>
          </>
        )}

        {value && (
          <>
            <img src={value} alt="Preview" className={styles.imagePreview} />
            <div className={styles.actionN}>
              {!disabled && (
                <Button
                  label="Remove"
                  className={styles.cButton}
                  type="button"
                  onClick={() => {
                    if (inputArgs?.onChange) {
                      inputArgs.onChange("");
                    }
                  }}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(ImagePicker);
